const nowMs = () => new Date().getTime();

const DEFAULT_TICK = 250;

// eslint-disable-next-line
export class Interval {
  tick

  intervalId

  interval

  onTick

  onInterval

  lastInterval

  remaingTime

  constructor(interval) {
    this.interval = interval;
    this.tick = DEFAULT_TICK;
    this.onTick = [];
    this.onInterval = [];
  }

  start() {
    if (this.intervalId == null) {
      this.setLastInterval();
      this.intervalId = setInterval(() => this.onTickEvent(), this.tick);
    }
  }

  stop() {
    if (this.intervalId != null) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  restart() {
    this.stop();
    this.start();
  }

  onTickEvent() {
    const remaingTime = this.getRemainingTime();

    this.onTick.forEach(t => t(remaingTime));
    if (remaingTime === 0) {
      this.onInterval.forEach(l => l());
      this.setLastInterval();
    }
  }

  getRemainingTime() {
    // eslint-disable-next-line no-mixed-operators
    const remaingTime = this.lastInterval + this.interval - nowMs();
    if (remaingTime < 0) {
      return 0;
    }
    return remaingTime;
  }

  setLastInterval() {
    this.lastInterval = nowMs();
  }
}
